import { instance, reqHeaders } from './axiosInterceptor';

export const dbGet = async url => {
  const response = await instance.get(url);
  return response.data.results;
};

export const dbPost = async (url, param) => {
  const isFormData = param instanceof FormData;
  const config = isFormData ? {} : {}; 
  const response = await instance.post(url, param, config);
  return response.data.results;
};

export const dbPut = async (url, param) => {
  const response = await instance.put(url, param);

  return response.data.results;
};

export const dbDelete = async (url, param) => {
  const response = await instance.delete(url, { data: param });
  return response.data.results;
};

export const dbForm = async (url, formData) => {
    try {
        const response = await instance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.results;
    } catch (error) {
        throw error;
    }
};